// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3yV2h","alertIcon":"ConfirmModal_alertIcon__2UV4s"};